import type { Role } from '../permissions';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class RoleFactory extends ObjectFactory<Role> {
  protected getDefaults(): Role {
    return {
      ...baseDocumentFactory.build(),
      key: 'TENANT_ADMIN',
      permissions: ['permissions:read', 'roles:read', 'roles:write', 'users:read', 'users:write'],
    };
  }
}

export type { Role };
export const roleFactory = new RoleFactory();
